import styles from "./heading-carousel.styles.module.scss";
import {HeadingCarouselProps} from "./heading-carousel.types";

export const HeadingCarousel = ({title, subtitle, icon, onPrev, onNext, showArrowsOnMobile = false}) => {
  return (
    <div className={styles.container}>
      <div className={styles.titBoxWra}>
        <span
          role="img"
          aria-label="play"
          className={styles.icon}
        >
          {icon}
        </span>

        <div className={styles.titBox}>
          <p className={styles.title}>{title}</p>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>

        <div className={styles.actions}>
          {/* {viewAllLink && (
            <Link
              to={viewAllLink}
              className={styles.viewAllBtn}
              onClick={handleViewAllClick}
            >
              {t("viewAll", "Ver todo")}
              <span className={styles.viewAllArrow}>›</span>
            </Link>
          )} */}

          {onPrev && onNext && (
            <div className={`${styles.arrowGroup} ${showArrowsOnMobile ? styles.arrowGroupMobileVisible : ""}`}>
              <button
                type="button"
                className={styles.arrowBtn}
                onClick={onPrev}
                aria-label="Previous"
              >
                <svg
                  aria-hidden="true"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="15 18 9 12 15 6" />
                </svg>
              </button>
              <button
                type="button"
                className={styles.arrowBtn}
                onClick={onNext}
                aria-label="Next"
              >
                <svg
                  aria-hidden="true"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="9 6 15 12 9 18" />
                </svg>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

HeadingCarousel.propTypes = HeadingCarouselProps;
